import { render, staticRenderFns } from "./docKI.vue?vue&type=template&id=bd95bb92&scoped=true"
import script from "./docKI.vue?vue&type=script&lang=js"
export * from "./docKI.vue?vue&type=script&lang=js"
import style0 from "./docKI.vue?vue&type=style&index=0&id=bd95bb92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd95bb92",
  null
  
)

export default component.exports